import {PieChart as PieChartIcon} from "react-feather";

const sections = [
    {
        title: 'Home',
        icon: PieChartIcon,
        href: '/app/patient/home'
    },
    {
        title: 'Questionari',
        icon: PieChartIcon,
        href: '/app/patient/questionnaires'
    },
    {
        title: 'Servizi',
        icon: PieChartIcon,
        href: '/app/patient/services'
    },
    {
        title: 'Appuntamenti',
        icon: PieChartIcon,
        href: '/app/patient/requests'
    }
]

export default sections;
